import React, { Dispatch, SetStateAction, useState } from "react";
import styles from "./styles.module.scss";
import { toggleFilter } from "../../Services/Utils";
// Components
import Modal from "../Modal";
import {
  NavigateNextIcon,
  ArrowBackIcon,
  RadioButtonUncheckedIcon,
  CheckCircleOutlineIcon,
} from "../../Styles/Icons";
import { Filters, StaffFilter } from "Pages/Staff";

interface FilterCategoryProps {
  onClick: () => void;
  name: string;
}

const FilterCategory = ({ onClick, name }: FilterCategoryProps) => (
  <div onClick={onClick} className={styles.filter_category}>
    <div>{name}</div>
    <NavigateNextIcon />
  </div>
);

interface FilterItemProps {
  onClick: () => void;
  item: Filters;
}

const FilterItem = ({ item, onClick }: FilterItemProps) => (
  <div className={styles.filter_item}>
    <div>{item?.name}</div>
    {item?.filtered ? (
      <CheckCircleOutlineIcon onClick={onClick} style={{ cursor: "pointer" }} />
    ) : (
      <RadioButtonUncheckedIcon
        onClick={onClick}
        style={{ cursor: "pointer" }}
      />
    )}
  </div>
);

interface FilterProps {
  show: boolean;
  hide: () => void;
  filters: StaffFilter;
  setFilters: Dispatch<SetStateAction<StaffFilter>>;
}

const Filter = ({ show, hide, filters, setFilters }: FilterProps) => {
  const [filterSelected, setFilterSelected] = useState("");

  return (
    <Modal
      show={show}
      hide={hide}
      title="Filter your lilli users"
      context="Filters allow you to investigate a subset of your users, e.g. those at risk"
    >
      <div className={styles.container}>
        <div className={styles.title}>
          {filterSelected ? (
            <ArrowBackIcon
              onClick={() => {
                setFilterSelected("");
              }}
              style={{ cursor: "pointer" }}
            />
          ) : (
            <div></div>
          )}
          <h3>{filterSelected}</h3>
          <div />
        </div>

        {!filterSelected && (
          <div className={styles.filters}>
            {filters.map((filter) => (
              <FilterCategory
                onClick={() => setFilterSelected(filter.type)}
                name={filter.type}
              />
            ))}
          </div>
        )}
        {/* Slightly unfortunate naming here with the variable "filter" and the method "filter" */}
        {filterSelected && (
          <div className={styles.results}>
            {filters
              .filter((filter) => filter.type === filterSelected)[0]
              .filters.map((filter, index) => (
                <FilterItem
                  key={index}
                  item={filter}
                  onClick={() =>
                    toggleFilter(filter.id, filterSelected, setFilters)
                  }
                />
              ))}
          </div>
        )}
      </div>
    </Modal>
  );
};

export default Filter;
